import CreateNewClassForm from './CreateNewClassForm';

export default CreateNewClassForm;
